import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSubscription } from '@/context/SubscriptionContext';
import { useSupabaseInventory } from '@/context/SupabaseInventoryContext';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Crown, X, TrendingUp } from 'lucide-react';

// Routes où NE PAS afficher le bandeau
const EXCLUDED_ROUTES = ['/auth', '/onboarding'];

export const PremiumBanner: React.FC = () => {
  const location = useLocation();
  const { hasAccess, createCheckout, isLoading } = useSubscription();
  const { products } = useSupabaseInventory();

  // Ne pas afficher le bandeau si l'utilisateur a déjà accès
  if (hasAccess) {
    return null;
  }

  // Ne pas afficher sur les pages d'auth et d'onboarding
  if (EXCLUDED_ROUTES.some(route => location.pathname.startsWith(route))) {
    return null;
  }

  const productCount = products.length;
  const remainingProducts = Math.max(0, 5 - productCount);
  const isNearLimit = productCount >= 4;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4">
      <Card className="bg-gradient-to-r from-amber-500 to-orange-500 border-none text-white shadow-2xl">
        <div className="flex items-center justify-between p-4">
          <div className="flex items-center space-x-3">
            <Crown className="w-6 h-6 text-amber-100" />
            <div>
              <h3 className="font-bold text-white">
                {isNearLimit ? '⚠️ Limite atteinte bientôt !' : 'Mode Démo'}
              </h3>
              <p className="text-sm text-amber-100">
                {productCount}/5 produits utilisés • {remainingProducts} restants
              </p>
            </div>
          </div>

          <div className="flex items-center space-x-3">
            <div className="hidden sm:flex items-center space-x-2 text-sm text-amber-100">
              <TrendingUp className="w-4 h-4" />
              <span>Accès illimité avec Starter</span>
            </div>
            
            <Button
              onClick={createCheckout}
              disabled={isLoading}
              variant="secondary"
              className="bg-white text-amber-600 hover:bg-amber-50 font-semibold"
            >
              {isLoading ? (
                <div className="animate-spin w-4 h-4 border-2 border-amber-600 border-t-transparent rounded-full" />
              ) : (
                <>
                  <Crown className="w-4 h-4 mr-2" />
                  Passer à Starter
                </>
              )}
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
};